import { useAuth } from "@/context/AuthContext";
import { useLang } from "@/context/LangContext";
import { ListingInterestToggle } from "@/components/ListingInterestToggle";
import { ContactSellerDialog } from "@/components/ContactSellerDialog";
import { RevealListingPhone } from "@/components/RevealListingPhone";
import { BuyMachineButton } from "@/components/BuyMachineButton";
import { isRentalListing } from "@/components/ListingCard";

function sameUserId(a, b) {
  const left = a == null ? "" : String(a).trim();
  const right = b == null ? "" : String(b).trim();
  return Boolean(left) && Boolean(right) && left === right;
}

/** Intéressé + Contacter / Téléphone / Acheter — sous la photo des cartes annonce. */
export function ListingCardActions({ listing, onUpdated, className = "" }) {
  const { user } = useAuth();
  const { t } = useLang();

  if (!listing?.id) return null;

  const sellerId = listing.seller_id || listing.seller?.id;
  const isOwner = Boolean(user && sameUserId(user.id, sellerId));
  const status = listing.status || "published";
  const isSold = status === "sold";
  const isReserved = status === "reserved";
  const rental = isRentalListing(listing);
  const phoneAvailable = Boolean(listing.phone || listing.phone_available);

  if (isOwner || isSold) return null;

  const stop = (e) => {
    e.preventDefault();
    e.stopPropagation();
  };

  return (
    <div
      className={`border-t border-matpro-border bg-white p-2 space-y-2 ${className}`}
      onClick={stop}
      onKeyDown={stop}
      data-testid={`listing-card-actions-${listing.id}`}
    >
      {(status === "published" || status === "pending" || status === "reserved") && (
        <ListingInterestToggle
          listing={listing}
          mode={rental ? "rental" : "sale"}
          variant="card"
          showWhenReserved
          onUpdated={onUpdated}
          className="w-full"
        />
      )}
      <div className="flex items-stretch gap-2">
        {rental ? (
          <>
            {!isReserved && phoneAvailable && (
              <RevealListingPhone
                listingId={listing.id}
                phoneAvailable={phoneAvailable}
                initialPhone={listing.phone}
                compact
                testId={`card-phone-${listing.id}`}
              />
            )}
            {!isReserved && (
              <ContactSellerDialog
                listing={listing}
                instant
                label={t("listing_detail.contact_seller")}
                testId={`card-contact-${listing.id}`}
                className="flex-1 min-w-0"
                buttonClassName="w-full h-11 min-h-11 flex-1 border-2 border-matpro-anthracite text-matpro-anthracite hover:bg-matpro-anthracite hover:text-white font-bold rounded-md text-sm"
              />
            )}
          </>
        ) : (
          <>
            {!isReserved && (
              <ContactSellerDialog
                listing={listing}
                instant
                label={t("card.contact")}
                testId={`card-contact-${listing.id}`}
                className="flex-1 min-w-0"
                buttonClassName="w-full h-11 min-h-11 flex-1 border-2 border-matpro-anthracite text-matpro-anthracite hover:bg-matpro-anthracite hover:text-white font-bold rounded-md text-sm px-2"
              />
            )}
            {!isReserved && phoneAvailable && (
              <RevealListingPhone
                listingId={listing.id}
                phoneAvailable={phoneAvailable}
                initialPhone={listing.phone}
                compact
                testId={`card-phone-${listing.id}`}
              />
            )}
            <BuyMachineButton
              listing={listing}
              onUpdated={onUpdated}
              label={t("listing_detail.buy_btn")}
              className="flex-1 min-w-0 !w-auto !h-11 !min-h-11 !text-sm !px-2"
            />
          </>
        )}
      </div>
    </div>
  );
}
